<div class="box_number">
  <div class="text">{{label}}</div>
  <div class="value">{{value}}</div>
</div>
